module.exports = __webpack_public_path__ + "media/images/top/top_user_img_03-1891dd5b4c1371042c6cf467beed762e.png";